import React, { useState } from 'react';
import {
  Box,
  Typography,
  Switch,
  FormControlLabel,
  TextField,
  Paper,
  Chip,
  Grid
} from '@material-ui/core';
import ChipInput from 'components/shared/ChipInput';
import strings from '../../../strings';

const SectionCard = ({ title, children }) => (
  <Paper
    elevation={1}
    style={{
      padding: 16,
      marginBottom: 16,
      borderRadius: 8,
      border: "1px solid #e3f2fd",
      backgroundColor: "var(--bg-canvas)",
    }}
  >
    <Typography variant="h6" style={{ fontWeight: 600, color: "var(--rox-lilac-ink)", marginBottom: 16 }}>
      {title}
    </Typography>
    {children}
  </Paper>
);

const ControlledUCCCriteriaForm = ({ value, onUpdatePolicy }) => {
  const handleToggle = (field, checked) => {
    if (onUpdatePolicy) {
      onUpdatePolicy(field, checked);
    }
  };

  const handleFieldChange = (field, newValue) => {
    if (onUpdatePolicy) {
      onUpdatePolicy(field, newValue);
    }
  };

  return (
    <Box>
      <SectionCard title={strings.MARKETPLACE.UCC_CONFIGURATION}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} style={{marginTop: "28px"}}>
            <TextField
              fullWidth
              label={strings.MARKETPLACE.MAXIMUM_ACTIVE_LIENS}
              variant="outlined"
              size="small"
              type="number"
              placeholder="e.g. 5"
              value={value?.maxActiveLiens || ""}
              onChange={(e) =>
                handleFieldChange('maxActiveLiens', e.target.value ? parseInt(e.target.value, 10) : null)
              }
              InputLabelProps={{ shrink: true }}
            />
            <Typography variant="caption" color="textSecondary" display="block" mt={1}>
              {strings.MARKETPLACE.MAX_LIENS_HELP}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <ChipInput
              label={strings.MARKETPLACE.EXCLUDED_SECURED_PARTIES}
              values={value?.excludedSecuredParties || []}
              onChange={(v) => handleFieldChange('excludedSecuredParties', v)}
              placeholder={strings.MARKETPLACE.SECURED_PARTIES_PLACEHOLDER}
              helperText="Type a secured party name and select from the dropdown to add it"
            />
          </Grid>
        </Grid>
      </SectionCard>
    </Box>
  );
};

export default ControlledUCCCriteriaForm;